module.exports = __webpack_public_path__ + "UP.svg?ed0e6e0fd31f2c6d192194cc972167d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/UP.svg
// module id = 72
// module chunks = 0